<script setup>
import { useI18n } from "vue-i18n";
import { FormCheckboxGroup, FormCheckboxGroupOption } from "@Components/Form";

defineProps(["modelValue", "sources"]);
defineEmits(["update:modelValue"]);

const { t: __ } = useI18n();
</script>

<template>
    <FormCheckboxGroup :label="__('Sources')">
        <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 sm:grid-cols-2">
            <FormCheckboxGroupOption
                v-for="source in sources"
                :key="source.key"
                v-model="modelValue.sources[source.key]"
                :title="source.name"
                :description="source.description" />
        </div>
    </FormCheckboxGroup>
</template>
